// Fixed sample users for prototype mode.
// Credentials are intentionally plaintext — this data never leaves localStorage.
//
// | Email                       | Password    | Role         |
// |-----------------------------|-------------|--------------|
// | student@demo.com            | Demo1234!   | student      |
// | admin@greenwood.com         | Admin1234!  | school_admin |
// | super@earlyscape.com        | Super1234!  | super_admin  |

export const SAMPLE_USER_IDS = {
  student:    'a1b2c3d4e5f6a1b2c3d4e5f6',
  schoolAdmin: 'b2c3d4e5f6a1b2c3d4e5f6a1',
  superAdmin:  'c3d4e5f6a1b2c3d4e5f6a1b2',
} as const;

export const SAMPLE_SCHOOL_ID = 'd4e5f6a1b2c3d4e5f6a1b2c3';
export const SAMPLE_STUDENT_PROFILE_ID = 'e5f6a1b2c3d4e5f6a1b2c3d4';

const now = new Date('2024-09-01T00:00:00.000Z');

export const sampleUsers = [
  {
    _id: SAMPLE_USER_IDS.student,
    email: 'student@demo.com',
    password: 'Demo1234!',
    userType: 'student' as const,
    status: 'active' as const,
    emailVerified: true,
    loginAttempts: 0,
    twoFactorEnabled: false,
    name: 'Adaeze Nnamdi',
    avatarUrl: 'https://api.dicebear.com/7.x/avataaars/svg?seed=adaeze',
    grade: 'SS2',
    role: 'student' as const,
    joinDate: now,
    totalPoints: 1240,
    tasksCompleted: 18,
    streakDays: 5,
    level: 4,
    rank: 12,
    schoolName: 'Greenwood High School',
    studentProfile: SAMPLE_STUDENT_PROFILE_ID,
    preferences: {
      notifications: true,
      soundEffects: false,
      theme: 'light' as const,
      language: 'en',
      timezone: 'Africa/Lagos',
      notificationSettings: { email: true, push: true, sms: false },
    },
    metadata: { registrationSource: 'web' },
    createdAt: now,
    updatedAt: now,
    isDeleted: false,
  },
  {
    _id: SAMPLE_USER_IDS.schoolAdmin,
    email: 'admin@greenwood.com',
    password: 'Admin1234!',
    userType: 'school_admin' as const,
    status: 'active' as const,
    emailVerified: true,
    loginAttempts: 0,
    twoFactorEnabled: false,
    name: 'Chukwuemeka Olabanji',
    avatarUrl: 'https://api.dicebear.com/7.x/avataaars/svg?seed=chukwuemeka',
    grade: '',
    role: 'school' as const,
    joinDate: now,
    totalPoints: 0,
    tasksCompleted: 0,
    streakDays: 0,
    level: 1,
    rank: 0,
    schoolName: 'Greenwood High School',
    schoolProfile: SAMPLE_SCHOOL_ID,
    preferences: {
      notifications: true,
      soundEffects: false,
      theme: 'light' as const,
      language: 'en',
      timezone: 'Africa/Lagos',
      notificationSettings: { email: true, push: false, sms: false },
    },
    metadata: { registrationSource: 'web' },
    createdAt: now,
    updatedAt: now,
    isDeleted: false,
  },
  {
    _id: SAMPLE_USER_IDS.superAdmin,
    email: 'super@earlyscape.com',
    password: 'Super1234!',
    userType: 'super_admin' as const,
    status: 'active' as const,
    emailVerified: true,
    loginAttempts: 0,
    twoFactorEnabled: false,
    name: 'Earlyscape Admin',
    avatarUrl: 'https://api.dicebear.com/7.x/avataaars/svg?seed=earlyscape',
    grade: '',
    role: 'super_admin' as const,
    joinDate: now,
    totalPoints: 0,
    tasksCompleted: 0,
    streakDays: 0,
    level: 1,
    rank: 0,
    preferences: {
      notifications: true,
      soundEffects: false,
      theme: 'light' as const,
      language: 'en',
      timezone: 'Africa/Lagos',
      notificationSettings: { email: true, push: true, sms: false },
    },
    metadata: { registrationSource: 'web' },
    createdAt: now,
    updatedAt: now,
    isDeleted: false,
  },
];
